import * as React from "react";
import DialogContentText from "@mui/material/DialogContentText";
import { Stack, TextField } from "@mui/material";
import CclDrawer from "../../../components/common/cclDrawer/cclDrawer";
import CclDrawerActionBar from "../../../components/common/cclDrawer/cclDrawerActionBar";
import CclButton from "../../../components/common/cclButtons/cclButton";
import {
    AssessmentAdminGroupDetail,
    CreateGroupRequest,
    UpdateGroupRequest,
} from "../../../services/types/assessmentAPITypes";
import CclLoadingButton from "../../../components/common/cclButtons/cclLoadingButton";

export type CclAddUpdateAdminGroupDrawerProps = {
    open: boolean;
    adminGroup?: AssessmentAdminGroupDetail;
    onCreate: (newGroup: CreateGroupRequest) => void;
    onUpdate: (updatedGroup: UpdateGroupRequest) => void;
    onCancel: () => void;
    operationInProgress: boolean;
};

const CclAddUpdateAdminGroupDrawer: React.FC<CclAddUpdateAdminGroupDrawerProps> = (props) => {
    const isEdit = props.adminGroup != null;
    const [groupName, setGroupName] = React.useState<string>(
        props.adminGroup != null ? props?.adminGroup.aagName : ""
    );

    const handleOk = () => {
        if (isEdit) {
            const updatedGroup: UpdateGroupRequest = {
                aagKey: props.adminGroup!.aagKey,
                name: groupName.trim(),
            };
            props.onUpdate(updatedGroup);
        } else {
            const newGroup: CreateGroupRequest = {
                name: groupName.trim(),
                isSharedGroup: true,
            };
            props.onCreate(newGroup);
        }
    };

    return (
        <CclDrawer
            open={props.open}
            title={isEdit ? "Update Group" : "Create Group"}
            onClose={props.onCancel}
        >
            <Stack direction="row" alignItems={"center"}>
                <DialogContentText id="alert-dialog-description" sx={{ width: 1 }}>
                    <TextField
                        size="small"
                        id="group-name"
                        label="Name"
                        variant="outlined"
                        onChange={(e) => {
                            setGroupName(e.target.value);
                        }}
                        fullWidth
                        value={groupName}
                        sx={{ m: 1, mt: 2 }}
                    />
                </DialogContentText>
            </Stack>
            <CclDrawerActionBar>
                <CclLoadingButton
                    onClick={handleOk}
                    disabled={groupName.trim() === "" || props.operationInProgress}
                    mode={"primary"}
                    loading={props.operationInProgress}
                >
                    {isEdit ? "Save" : "Create"}
                </CclLoadingButton>
                <CclButton onClick={props.onCancel} mode={"secondary"}>
                    Cancel
                </CclButton>
            </CclDrawerActionBar>
        </CclDrawer>
    );
};

export default CclAddUpdateAdminGroupDrawer;
